
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"},"content":"<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M20.5 4L25 8.52V26a2 2 0 01-2 2H9a2 2 0 01-2-2V6a2 2 0 012-2h11.5z\" fill=\"#2DE0A5\"/><path d=\"M20.5 4.002v3.501a1 1 0 001 1H25l-4.5-4.5z\" fill=\"#FFF\" opacity=\".5\"/><g fill=\"#FFF\" fill-rule=\"nonzero\"><path d=\"M10.75 16v-1.5h10.5V16zm0 3v-1.5h10.5V19z\"/><path d=\"M13.75 11.5h1.5V22h-1.5z\"/><path d=\"M11.5 13v7.5h9V13h-9zm0-1.5h9A1.5 1.5 0 0122 13v7.5a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 01-1.5-1.5V13a1.5 1.5 0 011.5-1.5z\"/></g></g>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
